export default (num: number) =>
  Math.abs(num) > 9999 ? `${(Math.sign(num) * (Math.abs(num) / 1000)).toFixed(2)}K` : Math.sign(num) * Math.abs(num)
